import { render } from "./LanguageSwitcher.vue?vue&type=template&id=0690d5f7&ts=true"
import script from "./LanguageSwitcher.vue?vue&type=script&lang=ts"
export * from "./LanguageSwitcher.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__